import React from 'react'

const Icon = ({ className, icon, ...props }) => {
  return <i className={`iconfont ${icon} ${className}`} {...props} />
}

export default Icon
